<template>
  <v-dialog v-model="visible" max-width="500" persistent>
    <v-card>
      <v-card-title>{{ title }}</v-card-title>
      <v-card-text>
        <v-alert
          outlined
          type="warning"
          prominent
          border="left"
          class="mb-0"
          v-if="message"
        >
          <div v-html="message"></div>
        </v-alert>
      </v-card-text>


      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="cancel">Отмена</v-btn>
        <v-btn color="primary" @click="confirm">OK</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      title: '',
      message: '',
      confirmCallback: null,
      rejectCallback: null
    }
  },
  methods: {
    show(title, message, confirmCallback, rejectCallback = null) {
      this.title = title;
      this.message = message;
      this.confirmCallback = confirmCallback;
      this.rejectCallback = rejectCallback;
      this.visible = true;
    },
    confirm() {
      if (this.confirmCallback) {
        this.confirmCallback()
      }
      this.visible = false
    },
    cancel() {
      if(this.rejectCallback) {
        this.rejectCallback();
        console.log('reject')
      }
      this.visible = false
    }
  }
}
</script>